export default __webpack_public_path__ + "static/media/unfilteredWaterMobile.04af612e.jpg";